import { getSegmentDefault } from "../segment/segmentState";

export default {
  interactions: null,
  totalInteractions: null,
  interactionCategories: null,
  filter: getSegmentDefault().rules.static
};
